import { Instagram } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#09090B] border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-20">
          <div className="md:col-span-5">
            <p className="font-mono-small text-[#E5D0A1] mb-6">— Sonoran Exterior Co.</p>
            <p className="font-body text-white/60 text-lg max-w-md leading-relaxed">
              A family-owned exterior restoration studio serving the greater
              Scottsdale area. Quiet, careful, and obsessive about the work.
            </p>
            <div className="mt-8 flex flex-wrap gap-2">
              {["Insured & Bonded", "ROC #312844", "BBB A+"].map((b) => (
                <span
                  key={b}
                  className="font-mono-small text-white/50 border border-white/15 px-3 py-1.5"
                >
                  {b}
                </span>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono-small text-white/40 mb-5">Service Areas</p>
            <ul className="space-y-2.5 font-body text-white/70">
              {[
                "Scottsdale",
                "Paradise Valley",
                "DC Ranch",
                "Silverleaf",
                "Cave Creek",
                "Carefree",
              ].map((c) => (
                <li key={c}>{c}</li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="font-mono-small text-white/40 mb-5">Reach Us</p>
            <ul className="space-y-3 font-body text-white/70">
              <li>
                <a
                  href="tel:+14805550120"
                  data-testid="footer-phone"
                  className="u-link text-white"
                >
                  (480) 555 — 0120
                </a>
              </li>
              <li>
                <a
                  href="mailto:hello@sonoranexterior.co"
                  data-testid="footer-email"
                  className="u-link"
                >
                  hello@sonoranexterior.co
                </a>
              </li>
              <li className="text-white/50">Mon–Sat · 7am — 7pm</li>
            </ul>
            <a
              href="#"
              data-testid="footer-instagram"
              className="inline-flex items-center gap-2 mt-6 text-white/60 hover:text-[#E5D0A1] transition-colors"
            >
              <Instagram className="w-4 h-4" strokeWidth={1.5} />
              <span className="font-mono-small">@sonoran.exterior</span>
            </a>
          </div>
        </div>

        {/* Mega wordmark */}
        <div className="border-t border-white/10 pt-12 pb-6 overflow-hidden">
          <h3 className="font-display text-white text-[18vw] sm:text-[16vw] lg:text-[14vw] leading-none tracking-[-0.06em] text-center sm:text-left whitespace-nowrap">
            sono<span className="font-editorial italic text-[#E5D0A1] font-normal">ran</span>
          </h3>
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 pt-8 border-t border-white/10">
          <p className="font-mono-small text-white/40">
            © {new Date().getFullYear()} Sonoran Exterior Co. All rights reserved.
          </p>
          <div className="flex gap-6 font-mono-small text-white/40">
            <a href="#" data-testid="footer-privacy">Privacy</a>
            <a href="#" data-testid="footer-terms">Terms</a>
            <span className="text-[#E5D0A1]">Built in Scottsdale</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
